import circleExclamationSrc from '@corbado/shared-ui/assets/circle-exclamation.svg';
import React, { memo, useRef } from 'react';
import { useIconWithTheme } from '../../../hooks/useIconWithTheme';
import { Icon } from './Icon';
export const CircleExclamationIcon = memo((props) => {
    const svgRef = useRef(null);
    const { logoSVG } = useIconWithTheme(svgRef, circleExclamationSrc, '--cb-error-text-color');
    return (React.createElement(Icon, { src: logoSVG, alt: 'exlamation-icon', ref: svgRef, ...props }));
});
